import { toast } from '@systemeio/ui'
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export const usePublisherErrorHandler = () => {
  const { t } = useLocoTranslation()
  const { redirectToMainPage } = useStoreQuery()

  const internalErrorHandler = async () => {
    toast.error(t('core.error.internal_error_message'))
    await redirectToMainPage()
  }

  return { internalErrorHandler }
}
